module.exports = __webpack_public_path__ + "89f3ddeea2e194a0199bd0d9978cbd26.png";